// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Sprössling": wächst von unten (scaleY), Blätter entfalten sich gestaffelt.
export default function Sproessling() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <g
        className="sproessling"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Erdhügel */}
        <path d="M30 102 C40 92 80 92 90 102 Z" fill="var(--sand)" />
        {/* kleine Steinchen */}
        <circle cx="34" cy="106" r="2" stroke="var(--moos)" />
        <circle cx="88" cy="107" r="2.5" stroke="var(--moos)" />
        {/* Spross (wächst von unten) */}
        <g className="sproessling-spross">
          {/* Stiel */}
          <path d="M60 98 C60 84 58 72 60 54" stroke="var(--moos)" strokeWidth="3" />
          {/* unteres Blatt links */}
          <g className="sproessling-blatt sproessling-blatt--1">
            <path d="M60 84 C48 84 40 76 38 64 C50 64 58 72 60 84 Z" fill="var(--moos)" />
            <path d="M58 82 C52 78 46 72 43 67" stroke="var(--creme)" strokeWidth="1.5" />
          </g>
          {/* mittleres Blatt rechts */}
          <g className="sproessling-blatt sproessling-blatt--2">
            <path d="M60 76 C72 76 80 68 82 56 C70 56 62 64 60 76 Z" fill="var(--salbei)" />
            <path d="M62 74 C68 70 74 64 77 59" stroke="var(--creme)" strokeWidth="1.5" />
          </g>
          {/* Spitzenblatt-Paar */}
          <g className="sproessling-blatt sproessling-blatt--3">
            <path d="M60 54 C52 50 48 42 48 34 C56 38 60 44 60 54 Z" fill="var(--moos)" />
            <path d="M60 54 C68 50 72 42 72 34 C64 38 60 44 60 54 Z" fill="var(--salbei)" />
          </g>
        </g>
      </g>
    </svg>
  )
}
